"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var platform_browser_1 = require("@angular/platform-browser");
var core_2 = require("@ngx-translate/core");
var merge_1 = require("rxjs/observable/merge");
var operators_1 = require("rxjs/operators");
var Config_1 = require("Config");
var logger_service_1 = require("./core/logger.service");
var i18n_service_1 = require("./core/i18n.service");
require("./app.component.scss");
var log = new logger_service_1.Logger('App');
var AppComponent = /** @class */ (function () {
    function AppComponent(router, activatedRoute, titleService, translateService, i18nService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.titleService = titleService;
        this.translateService = translateService;
        this.i18nService = i18nService;
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Setup logger
        if (Config_1.environment.production) {
            logger_service_1.Logger.enableProductionMode();
        }
        log.debug('init');
        // Setup translations
        this.i18nService.init(Config_1.environment.defaultLanguage, Config_1.environment.supportedLanguages);
        var onNavigationEnd = this.router.events.pipe(operators_1.filter(function (event) { return event instanceof router_1.NavigationEnd; }));
        // Change page title on navigation or language change, based on route data
        merge_1.merge(this.translateService.onLangChange, onNavigationEnd)
            .pipe(operators_1.map(function () {
            var route = _this.activatedRoute;
            while (route.firstChild) {
                route = route.firstChild;
            }
            return route;
        }), operators_1.filter(function (route) { return route.outlet === 'primary'; }), operators_1.mergeMap(function (route) { return route.data; }))
            .subscribe(function (event) {
            var title = event['title'];
            if (title) {
                _this.titleService.setTitle(_this.translateService.instant(title));
            }
        });
    };
    AppComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'app-root',
            template: require('./app.component.html')
        }),
        tslib_1.__metadata("design:paramtypes", [router_1.Router,
            router_1.ActivatedRoute,
            platform_browser_1.Title,
            core_2.TranslateService,
            i18n_service_1.I18nService])
    ], AppComponent);
    return AppComponent;
}());
exports.AppComponent = AppComponent;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.ts
// module id = 615
// module chunks = 0